/**
 * 処分業者
 */
 import Vue from 'vue'
 import * as httpConst from '../../../constants/httpConst'
 import * as types from '../../mutation-types/driver-types'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifests`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      keyword: null,
      driver_id: null,
      status: null,
      item: null,
      collected_date_type: null,
      collected_start_date: null,
      collected_end_date: null,
      manifest_type: null,
      sort_type: 'updated',
      search_keyword: null,
    },
  }
}

 const manifest = {

  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 処分業者一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param name
     * @param subscriber_number
     * @param page
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { keyword, status, driver_id, item, collected_date_type, collected_start_date, collected_end_date, manifest_type, sort_type, search_keyword, page, format, layout }) {
      dispatch('saveCondition', {
        keyword: keyword,
        driver_id: driver_id,
        status: status,
        item: item,
        collected_date_type: collected_date_type,
        collected_start_date: collected_start_date,
        collected_end_date: collected_end_date,
        manifest_type: manifest_type,
        search_keyword: search_keyword,
        sort_type: sort_type,
      })
      const params = {
        keyword: state.condition.keyword,
        driver_id: state.condition.driver_id,
        status: state.condition.status,
        item: state.condition.item,
        collected_date_type: state.condition.collected_date_type,
        collected_start_date: state.condition.collected_start_date,
        collected_end_date: state.condition.collected_end_date,
        manifest_type: state.condition.manifest_type,
        search_keyword: state.condition.search_keyword,
        sort_type: state.condition.sort_type,
        page: page,
        layout: layout,
      }
      return new Promise((resolve) => {
        const api_path = format === 'csv' ? `${API_PATH}.csv` : `${API_PATH}`
        Vue.$http.get(api_path, { params: params }).then(data => {
          if (format != 'csv') {
            let content = data.content
            commit(types.DRIVER_MANIFEST, { content })
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params, { headers: { 'content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}`
        Vue.$http.put(api_path, params, { headers: { 'content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { keyword, driver_id, status, item, collected_date_type, collected_start_date, collected_end_date, manifest_type, search_keyword, sort_type }) {
      const _keyword = (keyword !== undefined) ? keyword : state.condition.keyword
      const _driver_id = (driver_id !== undefined) ? driver_id : state.condition.driver_id
      const _status = (status !== undefined) ? status : state.condition.status
      const _item = (item !== undefined) ? item : state.condition.item
      const _collected_date_type = (collected_date_type !== undefined) ? collected_date_type : state.condition.collected_date_type
      const _collected_start_date = (collected_start_date !== undefined) ? collected_start_date : state.condition.collected_start_date
      const _collected_end_date = (collected_end_date !== undefined) ? collected_end_date : state.condition.collected_end_date
      const _manifest_type = (manifest_type !== undefined) ? manifest_type : state.condition.manifest_type
      const _search_keyword = (search_keyword !== undefined) ? search_keyword : state.condition.search_keyword
      const _sort_type = (sort_type !== undefined) ? sort_type : state.condition.sort_type
      const params = {
        keyword: _keyword,
        driver_id: _driver_id,
        status: _status,
        item: _item,
        collected_date_type: _collected_date_type,
        collected_start_date: _collected_start_date,
        collected_end_date: _collected_end_date,
        manifest_type: _manifest_type,
        sort_type: _sort_type,
        search_keyword: _search_keyword,
      }
      commit(types.DRIVER_MANIFEST_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_MANIFEST_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_MANIFEST_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_MANIFEST_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_MANIFEST_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.DRIVER_MANIFEST] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_MANIFEST_CONDITION] (state, { params }) {
      state.condition.keyword = params.keyword
      state.condition.driver_id = params.driver_id
      state.condition.status = params.status
      state.condition.item = params.item
      state.condition.collected_date_type = params.collected_date_type
      state.condition.collected_start_date = params.collected_start_date
      state.condition.collected_end_date = params.collected_end_date
      state.condition.manifest_type = params.manifest_type
      state.condition.search_keyword = params.search_keyword
      state.condition.sort_type = params.sort_type
    }
  },

 }

 export default manifest
